import { OffersCombinedApiClient } from '@fourthwall/services/dist/OffersCombinedApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferCombinedCreationMutation = createMutationHook(
  OffersCombinedApiClient.createOfferCombined,
  {
    mutationKey: ['offerCombinedCreation'],
  },
)
